import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .event-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    .event-page-area {
      flex: 1;
      padding: 70px 0;
      .event-box {
        margin-bottom: 30px;
        .event-img {
          width: 250px;
          height: 180px;
          overflow: hidden;
          border-radius: 5px;
          background-color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;

          a {
            display: block;
            width: 100%;
            height: 100%;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              background-color: #ffffff;
              border-radius: 5px;
            }
          }

          @media (max-width: 991px) {
            display: none;
          }
        }

        .event-content {
          position: relative;
          .content-box {
            box-shadow: 0 0px 20px rgba(0, 0, 0, 0.08);
            padding: 20px;
            background: #ffffff;
            border-radius: 5px;
            position: relative;
            margin-bottom: 30px;
            z-index: 1;
            .event-title {
              h6 {
                margin-bottom: 10px;
                a {
                  color: ${colors.black1};
                  font-weight: 600;

                  &:hover {
                    color: ${colors.red};
                  }
                }
              }
            }

            .event-time-location {
              margin-bottom: 10px;
              ul {
                li {
                  font-size: 13px;
                  color: ${colors.text3};
                  i {
                    font-size: 18px;
                    color: ${colors.red};
                    vertical-align: top;
                  }
                  &:first-child {
                    margin-right: 20px;
                  }
                }
              }
            }

            .event-desc {
              p {
                font-size: 13px;
                color: ${colors.text2};
                line-height: 20px;
              }

              @media (max-width: 767px) {
                margin-bottom: 10px;
              }
            }

            .event-date {
              position: relative;
              margin-bottom: 20px;
              padding-top: 6px;

              &:before {
                position: absolute;
                content: "";
                background: ${colors.border1};
                width: 1px;
                height: 100px;
                top: 0;
                left: -30px;

                @media (max-width: 767px) {
                  content: none;
                }
              }

              p {
                font-size: 20px;
                color: ${colors.red};
                font-weight: 500;
                text-transform: uppercase;

                @media (max-width: 767px) {
                  float: left;
                  font-size: 18px;
                  margin-right: 20px;
                }
              }

              @media (max-width: 767px) {
                margin-bottom: 0;
                padding-top: 0;
              }
            }

            .like-btn {
              button {
                font-size: 13px;
                color: ${colors.red};
                border: 1px solid ${colors.red};
                font-weight: 600;
                text-transform: uppercase;
                padding: 8px 14px;
                border-radius: 5px;
                background: transparent;
                display: inline-flex;
                align-items: center;
                gap: 6px;

                &:hover,
                &:focus {
                  color: #ffffff;
                  background: ${colors.red_bg};
                  border-color: ${colors.red};
                }

                &:disabled {
                  opacity: 0.6;
                  cursor: not-allowed;
                  background: ${colors.border1};
                  border-color: ${colors.border3};
                  color: ${colors.text3};
                }

                @media (max-width: 767px) {
                  float: left;
                  padding: 6px 12px;
                }
              }
            }

            @media (max-width: 991px) {
              position: unset;
            }
          }
        }
      }

      ul.pagination-box {
        margin-top: 50px;
      }

      .pagination-controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 15px;
        flex-wrap: wrap;

        .page-info {
          font-size: 14px;
          color: ${colors.text3};
        }

        .page-actions {
          display: flex;
          align-items: center;
          gap: 10px;

          button {
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
          }
        }
      }

      .course-sidebar {
        @media (max-width: 991px) {
          display: none;
        }
      }

      @media (max-width: 767px) {
        padding: 40px 0 35px;
        height: auto;
      }
    }
  }
`;
